<template>
  <div class="OneStopService">
    <div class="inner_center">
      <div class="headline">企业VIP可享受一站式服务</div>
      <div class="service-content">
        <div
          v-for="(vo,idx) in INTRO_COMPANY.ONE_STOP_SERVICE.LABEL_LIST"
          :key="idx"
          class="service-item"
        >
          <i
            class="icon_hexagon"
            v-html="vo"
          />
          <div class="service-desc">
            {{ INTRO_COMPANY.ONE_STOP_SERVICE.DESC_LIST[idx] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {INTRO_COMPANY} from "@/constant/intro/INTRO_COMPANY";

export default {
  name: "OneStopService",
  data() {
    return {
      INTRO_COMPANY
    }
  }
}
</script>

<style lang="scss" scoped>
.OneStopService {
  width: 100%;
  height: 728px;
  background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 75%, #F5F6FA 100%);

  .inner_center {

    .headline {
      font-size: 32px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 42px;
      letter-spacing: 1px;
      text-align: center;
      padding: 56px 0 54px;
    }

    .service-content {
      display: flex;
      flex-wrap: wrap;

      .service-item {
        width: 20%;
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .icon_hexagon {
          @include BgImage(126px, 138px, 'introduce/company/OneStopService/service-item-bg.png');
          @include LayoutFlex(1);
          text-align: center;
          line-height: 26px;
          font-size: 17px;
          font-weight: bold;
          color: #5B2600;
        }
        .service-desc{
          width: 164px;
          height: 66px;
          font-size: 14px;
          color: #0A2540;
          line-height: 22px;
          text-align: center;
          margin-top: 8px;
        }
      }
    }

  }
}
</style>
